module.exports = new __parcel__URL__("Bronze1.873cd9b3.png").toString();